import { AxiosRequestConfig } from 'axios';
import { ApiConfig } from '../types';

const endpoint = '/api';

export default {
    testAPI: (data: ApiConfig) => ({ method: 'POST', url: `${endpoint}/test-api`, data } as AxiosRequestConfig),
};
